import React from "react";
import NoFound4041 from "../../Backgrounds/NoFound4041.png";

const NoFound = () => {
    return(
        <>
        <h1>¿ Are You Lost ?  </h1>
        <h2>¿ Page Not Found ?  </h2>
        <img src={NoFound4041} alt="imagen" ></img>
        </>
    )
}

export default NoFound;